(function ($) {
  /*
   * add to cart
   */
  var $cartItemCount = $('.js-cart-item-count');
  var $cartAmountProductsOriginal = $('.js-cart-amount-products-original');
  var $cartAmountProducts = $('.js-cart-amount-products');
  var $cartAmountRecycle = $('.js-cart-amount-recycle');
  var $cartAmountVat = $('.js-cart-amount-vat');
  var $cartAmountTotal = $('.js-cart-amount-total');

  function updateCartInfo (r) {
    $cartItemCount.html(r['summary']['items_count']);
    $cartAmountProductsOriginal.html(r['summary']['amount_products_original_formatted']);
    $cartAmountProducts.html(r['summary']['amount_products_formatted']);
    $cartAmountRecycle.html(r['summary']['amount_recycle_formatted']);
    $cartAmountVat.html(r['summary']['amount_vat_formatted']);
    $cartAmountTotal.html(r['summary']['amount_total_formatted']);
  }

  var add = function ($form) {
    var $input = $form.find('[name="quantity"]');
    var val = $input.val();

    if (val && val === $input.data('prev')) {
      return;
    }

    hideAllTooltips();
    $input.data('prev', val);

    $.ajax({
      dataType: 'json',
      url: $form.attr('action'),
      data: $form.serialize(),
      success: function (r) {
        hideAllTooltips();
        $input.val(r['quantity'] ? r['quantity'] : '');
        updateCartInfo(r);
      }
    });
  };

  $('.js-add-to-cart')
    .each(function () {
      var $form = $(this);
      var $input = $form.find('[name="quantity"]');
      $input.data('prev', $input.val());
    })
    .on('submit', function (e) {
      hideAllTooltips();
      add($(this));
      return stopEvent(e);
    });

  /*
   * cart page remove product
   */
  // $('.js-remove-from-cart').on('click', function (e) {
  //   var $this = $(this);
  //
  //   hideAllTooltips();
  //
  //   if (confirm($this.data('message'))) {
  //     hideAllTooltips();
  //     $.getJSON($this.attr('href'), function (r) {
  //       $cartItemCount.html(r['summary']['items_count']);
  //       $cartAmountProducts.html(r['summary']['amount_products_formatted']);
  //       $this.closest('tr').remove();
  //     });
  //   }
  //
  //   return stopEvent(e);
  // });

  /*
   * cart page update quantities
   */
  // $('.js-update-cart-quantities').on('click', function (e) {
  //   var $this = $(this);
  //   var $form = $this.closest('form');
  //
  //   hideAllTooltips();
  //
  //   $.ajax({
  //     dataType: 'json',
  //     url: $this.attr('action'),
  //     data: $form.serialize() + '&update=true',
  //     success: function (r) {
  //       hideAllTooltips();
  //       updateCartInfo(r);
  //       $.each(r['summary']['items'], function (id, data) {
  //         $('#item-' + id + ' .product-price').html(data['price_html']);
  //         $('#item-' + id + ' .product-subtotal').html(data['amount_formatted']);
  //       });
  //     }
  //   });
  //   return stopEvent(e);
  // });

  /*
   * set active branch
   */
  $('.js-set-branch').on('change', function (e) {
    var $this = $(this);

    hideAllTooltips();

    $.ajax({
      dataType: 'json',
      url: $this.attr('action'),
      data: { set_branch: $this.find('option:selected').val() },
      success: function (r) {
        hideAllTooltips();
        updateCartInfo(r);
      }
    });
    return stopEvent(e);
  });
})(jQuery);
